import { Users, Building2, DollarSign, TrendingUp, QrCode } from 'lucide-react';
import { LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Icon from '../../../components/AppIcon';


const AnalyticsDashboard = () => {
  const stats = [
    {
      label: 'Usuarios Totales',
      value: '2,847',
      change: '+12.5%',
      trend: 'up',
      icon: Users,
      color: 'text-blue-600',
      bgColor: 'bg-blue-50'
    },
    {
      label: 'Empresas Registradas',
      value: '456',
      change: '+8.2%',
      trend: 'up',
      icon: Building2,
      color: 'text-purple-600',
      bgColor: 'bg-purple-50'
    },
    {
      label: 'Ingresos del Mes',
      value: '$48.5M',
      change: '+23.1%',
      trend: 'up',
      icon: DollarSign,
      color: 'text-green-600',
      bgColor: 'bg-green-50'
    },
    {
      label: 'Escaneos QR',
      value: '12,394',
      change: '+15.8%',
      trend: 'up',
      icon: QrCode,
      color: 'text-orange-600',
      bgColor: 'bg-orange-50'
    }
  ];

  const userGrowthData = [
    { month: 'Jul', users: 1850 },
    { month: 'Ago', users: 2100 },
    { month: 'Sep', users: 2400 },
    { month: 'Oct', users: 2650 },
    { month: 'Nov', users: 2800 },
    { month: 'Dic', users: 2847 }
  ];

  const revenueData = [
    { month: 'Jul', revenue: 32.5 },
    { month: 'Ago', revenue: 36.8 },
    { month: 'Sep', revenue: 41.2 },
    { month: 'Oct', revenue: 44.6 },
    { month: 'Nov', revenue: 46.9 },
    { month: 'Dic', revenue: 48.5 }
  ];

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-foreground mb-2">
          Dashboard de Análisis
        </h1>
        <p className="text-muted-foreground">
          Métricas y estadísticas generales de la plataforma BIZZNET
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats?.map((stat, index) => {
          const Icon = stat?.icon;
          return (
            <div key={index} className="bg-card rounded-lg border shadow-sm p-6">
              <div className="flex items-center justify-between mb-4">
                <div className={`p-3 rounded-lg ${stat?.bgColor}`}>
                  <Icon className={`w-6 h-6 ${stat?.color}`} />
                </div>
                <div className="flex items-center gap-1 text-sm text-green-600">
                  <TrendingUp className="w-4 h-4" />
                  <span className="font-semibold">{stat?.change}</span>
                </div>
              </div>
              <h3 className="text-2xl font-bold text-foreground mb-1">
                {stat?.value}
              </h3>
              <p className="text-sm text-muted-foreground">
                {stat?.label}
              </p>
            </div>
          );
        })}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-card rounded-lg border shadow-sm p-6">
          <h3 className="text-lg font-semibold text-foreground mb-4">
            Crecimiento de Usuarios
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <LineChart data={userGrowthData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Line 
                type="monotone" 
                dataKey="users" 
                stroke="#3b82f6" 
                strokeWidth={2}
                dot={{ fill: '#3b82f6', r: 4 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>

        <div className="bg-card rounded-lg border shadow-sm p-6">
          <h3 className="text-lg font-semibold text-foreground mb-4">
            Ingresos Mensuales (Millones COP)
          </h3>
          <ResponsiveContainer width="100%" height={300}>
            <BarChart data={revenueData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="month" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="revenue" fill="#10b981" radius={[8, 8, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsDashboard;